import { createContext, useEffect, useState } from 'react'

const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [userSubscribe, setUserSubscribe] = useState({})
  const [loading, setLoading] = useState(true)
  const [userInfo, setUserInfo] = useState(() => {
    const storedUser = localStorage.getItem('userInfo')
    return storedUser ? JSON.parse(storedUser) : null
  })

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'))
    
    if (storedUser) {
      setUser(storedUser)
      setUserInfo(storedUser.userInfo)
    }
    setLoading(false)
  }, [])

  const login = (data) => {
    localStorage.setItem('user', JSON.stringify(data))
    setUser(data)
    setUserInfo(data.userInfo)
  }

  const updateUserInfo = (newInfo) => {
    setUserInfo(newInfo);
    setUser(prev => {
      const updated = { ...prev, userInfo: newInfo };
      localStorage.setItem('user', JSON.stringify(updated));
      return updated;
    });
  };

  const logout = () => {
    localStorage.removeItem('user')
    setUser(null)
    setUserInfo(null)
    setUserSubscribe(null)
  }

  const conUserSubscribe = data => {
    setUserSubscribe(data)
  }

  return (
    <AuthContext.Provider
      value={{
        user,
        userInfo,
        setUserInfo,
        login,
        logout,
        userSubscribe,
        conUserSubscribe,
        loading,
        updateUserInfo
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export default AuthContext
